import { ApplicationApiResponse } from "../components/app-gallery/Applications";
import {
  applicationUrl,
  resendOtpApi,
  sessionStatusUrl,
  validateOtpApi,
  validateUserApi,
} from "../constants/Constants";
import UserEmailDetails from "../types/UserEmailDetails";

const fetchDataFromSvc = async <T>(url: string, options?: RequestInit): Promise<T | null> => {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch (err) {
    return null;
  }
};

export const checkSessionStatus = async () => {
  try {
    const response = await fetch(sessionStatusUrl, { credentials: "include" });
    return response.status === 200;
  } catch (err) {
    return false;
  }
};

export const makeHttpCallToValidateUser = async (
  username: string
): Promise<(UserEmailDetails & { error?: boolean; message?: string }) | null> => {
  try {
    const response = await fetch(`${validateUserApi}${username}`, undefined);
    if (!response.ok) {
      try {
        const errData = await response.json();
        const apiMessage = errData.message || "User Not Found";
        return { error: true, message: apiMessage } as any;
      } catch (e) {
        return { error: true, message: "User Not Found" } as any;
      }
    }
    return await response.json();
  } catch (err) {
    return null;
  }
};

export const checkUserSessionAndFetchApps = async (): Promise<ApplicationApiResponse | null> => {
  return fetchDataFromSvc<ApplicationApiResponse>(applicationUrl, { credentials: "include" });
};

export const resendOtp = async (authStateKey: string) => {
  return fetch(`${resendOtpApi}?authStateKey=${authStateKey}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const validateOtp = async (otp: string, authStateKey: string) => {
  return fetch(validateOtpApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      otp,
      authStateKey,
    }),
  });
};
